import DefaultLayout from 'components/layouts/default'
import services from 'services'
import SeoPageTemplate from 'components/ui/seopagetemplate'
import styles from 'components/ui/seopagetemplate/index.module.scss'
const Sectors = (props) => {
  return (
    <DefaultLayout
      canonical={`${process.env.NEXT_PUBLIC_MAIN_URL2}/sektore-gore-ilanlar`}
      {...props}
    >
      <SeoPageTemplate
        breadcrumb={props.breadcrumb}
        breadcrumbHead={props.breadcrumbHead}
      >
        <div className={`container ${styles['page-content-wrap']}`}>
          <h1>Sektöre göre ilanlar</h1>
          <div className={styles['data-list']}>
            <ul data-test={styles['seo-links']}>
              {props.sectors.items.map((sectors, index) => {
                return (
                  <li key={index}>
                    <a
                      href={
                        sectors.webSeoUrlName
                          ? props.startUrl + sectors.webSeoUrlName
                          : props.startUrl
                      }
                      title={sectors.webSeoUrlValue}
                    >
                      {sectors.webSeoUrlValue}
                    </a>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </SeoPageTemplate>
    </DefaultLayout>
  )
}

Sectors.getInitialProps = async (ctx) => {
  const pageSize = 94
  let pageNumber = 1
  if (ctx.query.pn > 0) pageNumber = ctx.query.pn

  const params = {
    PageNumber: pageNumber,
    PageSize: pageSize,
  }

  let resp
  try {
    resp = await services.wrapper(ctx, services.configs.seo.sectors.get, params)
  } catch (error) {
    //
  }

  let sectors = { items: [], total: 0 }
  let pageCount = 0
  if (resp && resp.data && resp.data.result) {
    sectors = resp.data && resp.data.result
    pageCount = Math.ceil(sectors.total / pageSize)
  }

  const startUrl = `${process.env.NEXT_PUBLIC_MAIN_URL2}/is-ilanlari/`

  return {
    sectors,
    pageNumber,
    pageSize,
    pageCount,
    startUrl,
    title: 'Sektöre Göre İlanlar',
    breadcrumb: [
      {
        text: 'Ana Sayfa',
        url: process.env.NEXT_PUBLIC_MAIN_URL2,
      },
      {
        text: 'Sektöre Göre İlanlar',
      },
    ],
    breadcrumbHead: {
      '@context': 'http://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Ana Sayfa',
          item: process.env.NEXT_PUBLIC_MAIN_URL2,
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'Sektöre Göre İlanlar',
        },
      ],
    },
  }
}

export default Sectors
